export default "__VITE_ASSET__DSae97UL__"